import * as angular from 'angular';
import { AppServicesModule } from '~/modules/mode-app-services';
import { SharedServicesModule } from '~/modules/mode-shared-services';
import { SharedUiModule } from '~/modules/shared-ui/shared-ui.module';
import { DowngradedChartsDomainModule } from '../../../downgraded-angular/charts/domain.module';
import { DatasetLinkModule } from '../dataset-link/dataset-link.module';
import { EncodingBuilderModule } from '../encoding-builder/encoding-builder.module';
import { BigValueFormatComponent } from './big-value-format.component';
import { ChartFormatComponent } from './chart-format.component';
import { TextFormatPanelComponent } from './text-format-panel.component';
import { VizSettingsComponent } from './viz-settings.component';

export const VizSettingsModule = angular
  .module('viz-settings', [
    DowngradedChartsDomainModule,
    SharedServicesModule,
    AppServicesModule,
    DatasetLinkModule,
    SharedUiModule,
    EncodingBuilderModule,
  ])
  .component('vizSettings', VizSettingsComponent)
  .component('bigValueFormat', BigValueFormatComponent)
  .component('textFormatPanel', TextFormatPanelComponent)
  .component('chartFormat', ChartFormatComponent).name;
